module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[44]43.5d5cdb6.woff2";